import React, {Component} from 'react';
import PropTypes from 'prop-types';

export class Wrapper extends Component {
    static get propTypes() {
        return {
            type: PropTypes.string,
            className: PropTypes.string,
            children: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.element),
                PropTypes.element,
            ]).isRequired,
            number: PropTypes.number,
        };
    }

    constructor(props) {
        super(props);
        this.resolveChildrenCount = this.resolveChildrenCount.bind(this);
    }


    resolveChildrenCount() {
        if (this.props.number) {
            return this.props.number;
        }

        if (!(this.props.children instanceof Array)) {
            return 1;
        }

        return this.props.children.length;
    }

    render() {
        return (
            <div className={`form-button-wrapper button-${this.resolveChildrenCount()} ${this.props.className}`}>
                {this.props.children}
            </div>
        );
    }
}
